export default (text: string, from = "_", to = "-"): string =>
  text ? text.split(from).join(to) : text;
